import React, { Suspense } from 'react';
import {Route} from 'react-router-dom';
import {has} from 'lodash-es';
import { routesConfig } from '../routesConfig';
import ErrorPageAuth from '../layouts/ErrorPageAuth';
import {get_random_guid} from '@Helpers/OtherHelper';
import SuspenseLoader from './customComponents/SuspenseLoader';

const routes = routesConfig
	.filter(x => !has(x, 'auth') || !x.auth)
	.map((value) => {
		return <Route 
			key = {value.path} 
			path={value.path} 
			element={
				<Suspense fallback={<SuspenseLoader /> }>
					{value.component}
				</Suspense>
			}
		/>;
	});

const finalRoutes = [
	...routes,
	<Route key={get_random_guid()} path={'*'} element={ <ErrorPageAuth/> } />
];

export const getNotAuthRoutes = finalRoutes;
